import { Typography } from '@branch-messenger/willow-ui'

import { supportRequestUrl } from '@/lib/urls'

export const GenericError = () => (
  <Typography $size="sm">
    An error occurred. Please try again or contact Branch support{' '}
    <a target="_blank" rel="noopener noreferrer" href={supportRequestUrl}>
      here
    </a>
  </Typography>
)
